export class MOTORRADListData {
  area?: string[];
  component?: string[];
  driveConditions?: string[];
  weatherConditions?: string[];
  kindOfNoise?: string[];
  sporadicOrPermanent?: string[];
}